import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const UserInfoContainer = styled.div`
  box-sizing: border-box;
  padding: 24px 16px 12px 16px;
  width: 100%;
  min-height: 54px;
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  cursor: pointer;
  &:hover {
    background-color: ${Variables.colors.primary_50};
  }
  .user-name {
    font-size: ${Variables.font_sizes.x2_large};
    color: ${Variables.colors.complementary_900};
    line-height: 1.55;
    margin-bottom: 6px;
    direction: ltr;
  }
  .profile-link {
    display: flex;
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.primary_vivid};
      line-height: 1.58;
      &:before,
      &:visited,
      &:hover,
      &:focus {
        color: ${Variables.colors.primary_vivid};
        font-weight: ${Variables.font_weight.medium};
      }
      i {
        display: flex;
        margin-right: 6px;
        &:before {
          font-size: 6px;
        }
      }
    }
  }
  .wallet {
    width: 100%;
    
  }
`;
export const Wallet = styled.div`
  height: 32px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 9px auto 0 auto;
  .label {
    font-size: ${Variables.font_sizes.x_small};
    font-weight: ${Variables.font_weight.medium};
    color: ${Variables.colors.complementary_800};
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      margin-left: 8px;
      &:before {
        font-size: ${Variables.font_sizes.x2_medium};
        color: ${Variables.colors.brown};
      }
    }
  }
  .amount {
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_800};
    span {
      margin-right: 7px;
    }
  }
`;
